import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { ListRenderItemInfo } from 'react-native';
import styled from 'styled-components/native';

import { Alert } from '~/components/alert';
import { Button } from '~/components/button';
import { List, ListItem } from '~/components/list';
import { ScreenContainer } from '~/components/screen';
import { Spacing } from '~/components/spacing';
import { Text } from '~/components/text';
import {
    clearPushNotificationLog,
    getPushNotificationLog,
    PushNotificationLogEntry
} from '~/contexts/push-notifications/push-notifications-log-persist';
import { AppNavigatorParamList } from '~/navigator/app-navigator';

type DeveloperPushNotificationsLogProps = object;

type Navigation = StackNavigationProp<AppNavigatorParamList>;

const CenteredView = styled.View`
    flex: 1;
    justify-content: center;
    align-items: center;
`;

const Toolbar = styled.View`
    padding: ${Spacing.MEDIUM}px;
`;

export const DeveloperPushNotificationsLog: FunctionComponent<DeveloperPushNotificationsLogProps> = () => {
    const { navigate } = useNavigation<Navigation>();
    const [entries, setEntries] = useState<PushNotificationLogEntry[]>([]);

    useEffect(() => {
        (async () => setEntries(await getPushNotificationLog()))();
    }, []);

    const onClear = () => {
        Alert.alert('Clear log', 'Remove all stored push notification entries?', [
            {
                text: 'Clear',
                onPress: async () => {
                    await clearPushNotificationLog();
                    setEntries([]);
                }
            },
            { text: 'Cancel' }
        ]);
    };

    const renderItem = ({ item }: ListRenderItemInfo<PushNotificationLogEntry>) => (
        <ListItem
            title={`${item.timestamp}`}
            description={
                (item.resolvedUrl ?? '<no url>') + (item.openLinkError ? ` — error: ${item.openLinkError}` : '')
            }
            onPress={() =>
                navigate('developer-json', {
                    title: 'Notification payload',
                    json: JSON.stringify(item, null, 2) as JSONString
                })
            }
        />
    );

    return (
        <ScreenContainer>
            <Toolbar>
                <Button label="Clear" onPress={onClear} disabled={entries.length === 0} />
            </Toolbar>
            {entries.length ? (
                <List<PushNotificationLogEntry> data={entries} renderItem={renderItem} />
            ) : (
                <CenteredView>
                    <Text.P1>No entries</Text.P1>
                </CenteredView>
            )}
        </ScreenContainer>
    );
};
